/* cd-nav-fx.js — CTA magnético + shimmer + cursor con personalidad (Horizon).
   FIX 2026-06-30: cursor más pegado al puntero (lerp 0.15 → 0.4) para quitar el lag.
   ========================================================================== */
(function () {
  "use strict";
  var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var FINE = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  function lerp(a, b, t) { return a + (b - a) * t; }

  function initMagnetic() {
    var btn = document.querySelector("[data-cd-magnetic]");
    if (!btn) return;
    var inner = btn.querySelector("[data-cd-magnetic-inner]");
    var shine = btn.querySelector(".cd-cta-shine");
    var gsap = window.gsap || null;

    if (shine && gsap && !REDUCED) {
      var sweep = function (dur) { gsap.fromTo(shine, { xPercent: -220 }, { xPercent: 220, duration: dur || 0.8, ease: "power2.inOut" }); };
      gsap.timeline({ repeat: -1, repeatDelay: 4.2 }).add(function () { sweep(0.8); });
      btn.addEventListener("mouseenter", function () { sweep(0.7); });
    }

    if (!FINE || REDUCED) return;
    if (btn.closest(".cd-hdr")) return; // el CTA del header no jala: absorbía el cursor camino al carrito (2026-09-01)
    document.documentElement.classList.add("cd-has-magnetic");

    var RADIUS = 80, mx = 0, my = 0, cx = 0, cy = 0, ix = 0, iy = 0, active = false, raf = null;
    function onMove(e) {
      var r = btn.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2), dy = e.clientY - (r.top + r.height / 2);
      if (Math.hypot(dx, dy) < RADIUS + Math.max(r.width, r.height) / 2) {
        mx = dx * 0.25; my = dy * 0.25;
        if (!active) { active = true; loop(); }
      } else { mx = 0; my = 0; }
    }
    function loop() {
      cx = lerp(cx, mx, 0.18); cy = lerp(cy, my, 0.18);
      ix = lerp(ix, mx * 1.6, 0.18); iy = lerp(iy, my * 1.6, 0.18);
      btn.style.transform = "translate3d(" + cx.toFixed(2) + "px," + cy.toFixed(2) + "px,0)";
      if (inner) inner.style.transform = "translate3d(" + (ix - cx).toFixed(2) + "px," + (iy - cy).toFixed(2) + "px,0)";
      var settled = Math.abs(cx - mx) < 0.05 && Math.abs(cy - my) < 0.05 && Math.abs(ix - mx * 1.6) < 0.05 && Math.abs(iy - my * 1.6) < 0.05;
      if (settled && mx === 0 && my === 0) { btn.style.transform = ""; if (inner) inner.style.transform = ""; active = false; return; }
      raf = requestAnimationFrame(loop);
    }
    window.addEventListener("mousemove", onMove, { passive: true });
  }

  function initCursor() {
    if (!FINE || REDUCED) return;
    document.documentElement.classList.add("cd-has-cursor");

    var dot = document.createElement("div"); dot.id = "cd-cursor-dot";
    var label = document.createElement("div"); label.id = "cd-cursor-label";
    document.body.appendChild(dot); document.body.appendChild(label);

    var INTERACTIVE = "a, button, input, [role='button'], [data-cd-hit]";
    var tx = window.innerWidth / 2, ty = window.innerHeight / 2, dx = tx, dy = ty, corriendo = false;
    // VELOCIDAD 23-oct-2026 (noche): el bucle se duerme cuando el punto ya llegó al puntero
    // (antes reescribía el estilo en CADA cuadro aunque el mouse estuviera quieto) y
    // despierta con el siguiente movimiento. Mismo cursor, mismo seguimiento.
    function loop() {
      dx = lerp(dx, tx, 0.4); dy = lerp(dy, ty, 0.4);
      var llego = Math.abs(dx - tx) < 0.1 && Math.abs(dy - ty) < 0.1;
      if (llego) { dx = tx; dy = ty; }
      dot.style.transform = "translate3d(" + dx.toFixed(2) + "px," + dy.toFixed(2) + "px,0)";
      label.style.transform = "translate3d(" + (tx + 16) + "px," + (ty + 10) + "px,0)";
      if (llego) { corriendo = false; return; }
      requestAnimationFrame(loop);
    }
    function despertar() { if (!corriendo) { corriendo = true; requestAnimationFrame(loop); } }
    window.addEventListener("mousemove", function (e) { tx = e.clientX; ty = e.clientY; despertar(); }, { passive: true });
    despertar();

    document.addEventListener("mouseover", function (e) {
      var t = e.target;
      if (t.closest && t.closest(INTERACTIVE)) dot.classList.add("is-hover");
      var lab = t.closest && t.closest("[data-cd-cursor-label]");
      if (lab) { label.textContent = lab.getAttribute("data-cd-cursor-label") || "Ver"; label.classList.add("show"); }
    });
    document.addEventListener("mouseout", function (e) {
      var t = e.target, rt = e.relatedTarget;
      if (t.closest && t.closest(INTERACTIVE) && !(rt && rt.closest && rt.closest(INTERACTIVE))) dot.classList.remove("is-hover");
      if (t.closest && t.closest("[data-cd-cursor-label]") && !(rt && rt.closest && rt.closest("[data-cd-cursor-label]"))) label.classList.remove("show");
    });
    document.addEventListener("mouseleave", function () { dot.style.opacity = "0"; label.classList.remove("show"); });
    document.addEventListener("mouseenter", function () { dot.style.opacity = ""; });
  }

  function start() { initMagnetic(); initCursor(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();